import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import cyberbunny from "../../Assets/Projects/cyberbunny.png"
import bees from "../../Assets/Projects/bees.png"
import designs from "../../Assets/Projects/designs.png"
import illustrations from "../../Assets/Projects/illustrations.png"
import inktober from "../../Assets/Projects/inktober.png"
import gameui from "../../Assets/Projects/gameui.png"
import gameuipresentation from "../../Assets/Projects/gameuipresentation.png"
import eventapp from "../../Assets/Projects/eventapp.png";
import pokemonCard from "../../Assets/PokemonCard.mov";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eventapp}
              title="Event App UI"
              description="A modern event management interface designed to streamline event planning and user interaction. Started from user flow mapping, then iterated through wireframes to a polished high-fidelity prototype with consistent layout and component structure."
              figmaLink="https://www.figma.com/proto/EUgeSgITSSa4uOgDayVXby/Untitled?page-id=0%3A1&node-id=12-2&viewport=209%2C555%2C0.23&t=hPp7fvVg8ICF8J0o-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=15%3A2"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gameui}
              title="Game UI Prototype"
              description="Wireframe prototype for a hyper-casual game spanning multiple historical eras. Each era required a distinct visual language while maintaining a consistent UX pattern — the challenge was balancing novelty with learnability across the full progression."
              figmaLink="https://www.figma.com/proto/mymfW1fgP5Fx0H1nty7VcN/Untitled?page-id=0%3A1&node-id=32-110&viewport=-2364%2C2721%2C0.61&t=IUJVM1xRkDNnqmxL-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=32%3A110"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gameuipresentation}
              title="Game UI Presentation"
              description="This is a hyper-casual tower defense and merge game where units evolve through different eras from Stone Age to Sci-Fi combining simple gameplay with cool visual progression."
              figmaLink="https://www.figma.com/deck/QDYFOT9C0HOqCTzL1kF86J/Untitled?node-id=1-42&viewport=18%2C-45%2C0.58&t=tJseUYJAtJg3tCOj-1&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cyberbunny}

              
              title="Cyberbunny"
              description="Work-in-progress design/prototype for the fictional Cyberbunny Caffee website, mixing a cyberpunk vibe with a cozy café feel. It is made to enhance my skills in Figma to discover new features."
              figmaLink="https://www.figma.com/proto/9DtQtXPOqiVuSCZe92r7LZ/Untitled?node-id=130-687&viewport=-2979%2C751%2C0.57&t=LoPoDojbqnmUqVAU-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=14%3A919&page-id=14%3A918"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              videoPath={pokemonCard}
              title="Pokemon Card"
              description="A custom Pokemon card design created in Figma, featuring original artwork and layout inspired by the official TCG style. Focused on typography, visual hierarchy, and attention to detail in recreating the card aesthetic."
              videoLink="/pokemon-card"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bees}
              title="I commissioned some Bees"
              description="Created level illustration for a published game available on Steam. Designed to fit the game's visual style while keeping the artwork clear and readable during gameplay."
              steamLink="https://store.steampowered.com/app/2277910/I_commissioned_some_bees_14/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={inktober}
              title="Inktober"
              description="A series of illustrations completed during Inktober 2024 — a month-long daily drawing challenge. Each piece responds to a daily prompt, pushing consistency, creative interpretation, and a range of styles across the month."
              figmaLink="https://www.figma.com/proto/U7AmAc9ntyeJss86ZWwKBu/inktober?page-id=0%3A1&node-id=1-290&viewport=169%2C663%2C0.06&t=zUUTQdZlMMiyYyrq-1&scaling=min-zoom&content-scaling=fixed"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={illustrations}
              title="Illustrations"
              description="A collection of personal illustrations spanning characters, animals, and conceptual pieces. Demonstrates range across styles — from detailed linework to looser, more expressive approaches."
              figmaLink="https://www.figma.com/proto/YTW61fLX6wS1MdFN5TrYJ4/illustrations?page-id=0%3A1&node-id=1-2&viewport=114%2C280%2C0.5&t=nJ1i3u7XPibiqjdt-1&scaling=min-zoom&content-scaling=fixed"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={designs}
              title="Designs"
              description="A selection of graphic design work including posters and a food menu. Each piece balances visual hierarchy, typography, and layout to communicate clearly and match the intended tone of the brief."
              figmaLink="https://www.figma.com/proto/XQnVtkXVGCAiXQ1TOaXdRZ/design?page-id=0%3A1&node-id=1-2&viewport=196%2C243%2C0.25&t=Q1i5F1I3NWdQdy4R-1&scaling=min-zoom&content-scaling=fixed"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
